module.exports = __webpack_public_path__ + "static/media/leave1.75a1ccda.svg";